<div>
  <nbc-breadcrumb></nbc-breadcrumb>
  <nbc-alert></nbc-alert>

  <div class="page-container-tbl">
    <div class="container-fluid-tbl">
      <div class="row-tbl">

        <div class="box-dash">
          <div class="tpm-box-dash-hdr-bar">
            <h2 class="tpm-box-dash-hdr">Manage Templates - {{selectedBuName}}</h2>
          </div>
          <div class="header-bar clearfix">
            <p class="heading-title pull-left">Timesheet Templates</p>
            <button type="button" class="btn btn-primary pull-right talent-payroll-btncls" (click)="openCreateTemplateModal()" authenticate-user="position.create">+ Create Template</button>
          </div>
          <div *ngIf="buAccess">
            <tpm-template-filter></tpm-template-filter>
            <tpm-template-list></tpm-template-list>
          </div>
        </div>


      </div>
    </div>
  </div>
</div> 
